import { render, staticRenderFns } from "./ComplementaryMeals.vue?vue&type=template&id=00358de4&scoped=true"
import script from "./ComplementaryMeals.vue?vue&type=script&lang=js"
export * from "./ComplementaryMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00358de4",
  null
  
)

export default component.exports